import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        width: 353,
        height: 'calc(100% - 110px)',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: 16,
        paddingTop: 8,
      },
      conversa: {
        width: '100%',
        borderLeftWidth: 4,
        borderLeftStyle: 'solid',
        borderLeftColor: sicrediStyle.secondarySicrediLight,
        color: sicrediStyle.secondarySicrediDarker,
        margin: `8px auto`,
        maxWidth: '100%',
      },
      respondido: {
        borderLeftColor: sicrediStyle.primarySicredi,
      },
      pendente: {
        borderLeftColor: sicrediStyle.warningSicredi,
      },
      ativo: {
        borderLeftColor: 'transparent',
        backgroundColor: sicrediStyle.primarySicrediDark,
        color: 'white',
      },
      item: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 8,
        boxSizing: 'border-box',
      },
      coopInfo: {
        flex: 'auto',
        fontSize: 14,
        fontWeight: 500,
        textAlign: 'left',
        lineHeight: '20px',
        color: sicrediStyle.primarySicredi,
        '$ativo &': {
          color: 'white',
        }
      },
      fullTime: {
        flex: 'auto',
        fontSize: 12,
        fontWeight: 'normal',
        textAlign: 'right',
        lineHeight: 1.33,
        color: sicrediStyle.secondarySicredi,
        '$ativo &': {
          color: 'white',
        }
      },
      associado: {
        fontSize: 17,
        fontWeight: 500,
        textAlign: 'left',
        width: '100%',
        lineHeight: '1.2em',
        margin: '6px 0',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      cpf: {
        fontSize: 14,
        fontWeight: 'normal',
        width: '100%',
        textAlign: 'left',
        lineHeight: '20px',
      },
      filtro: {
        display: 'flex',
        flexWrap: 'wrap',
      },
      select: {
        flexShrink: 0,
      },
      dropdownIcon: {
        fontSize: 16,
        color: sicrediStyle.primarySicredi,
      },
      chips: {
        flexShrink: 1,
        fontSize: 12,
        fontWeight: 'normal',
        margin: '8px auto',
        height: 28,
        '& .MuiChip-iconSmall': {
          width: 16,
          height: 16,
          marginLeft: 12,
        }
      },
      chipRespondidos: {
        backgroundColor: sicrediStyle.primarySicrediLight,
        color: sicrediStyle.primarySicrediDark,
        marginLeft: 0,
      },
      chipPendentes: {
        backgroundColor: sicrediStyle.warningSicrediLight,
        color: sicrediStyle.warningSicrediDark,
        marginRight: 0,
      },
    }),
  { name: 'ConversasAssessor' }
);